<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-3">
    <div class="flex items-center justify-between gap-2">
      <div class="flex flex-1 items-center gap-2">
        @if (isSearchBarVisible()) {
          <div iInputGroup>
            <IIcon name="search" />
            <input
              iInputGroupInput
              size="sm"
              [placeholder]="t('common.search')"
              [(ngModel)]="filter"
              (focusout)="!filter() ? isSearchBarVisible.set(false) : null"
              autoFocus
            />
          </div>
          <button iButton variant="secondary" size="xs" (click)="filter.set(''); isSearchBarVisible.set(false)">
            {{ t("common.close") }}
          </button>
        } @else {
          <button iButton variant="secondary" (click)="isSearchBarVisible.set(!isSearchBarVisible())">
            <IIcon name="search" />
            {{ t("common.search") }}
          </button>
        }
      </div>

      <div class="flex items-center gap-2">
        @if (keywordChecked().size > 0) {
          <button iButton variant="destructive" (click)="deleteCheckedKeywords()">
            <IIcon name="trash" />
            {{ t("common.delete") + " (" + keywordChecked().size + ")" }}
          </button>
        }

        <button iButton variant="secondary" [disabled]="keywords().length === 0" (click)="exportKeywordsAsCsv()">
          <IIcon name="upload" />
          {{ t("common.export") }}
        </button>
      </div>
    </div>

    <div class="scrollbar flex-[1_1_0] overflow-y-auto rounded-xl border border-gray-200">
      <div>
        @if (!isReadOnly()) {
          @if (isAddKeywordVisible()) {
            <div class="flex items-center gap-4 p-1">
              <div iInputGroup class="flex-1">
                <input
                  iInputGroupInput
                  [placeholder]="addInputPlaceholder()"
                  size="lg"
                  [formControl]="keywordInput"
                  (keydown.enter)="addKeywordFromInput($event)"
                  (paste)="$event.clipboardData && handlePaste($event.clipboardData.getData('text/plain'))"
                  autoFocus
                  [looseFocusOnEnter]="false"
                />
                <div class="pointer-events-auto flex items-center gap-2 bg-white pl-1" iInputGroupSuffix>
                  <button iButton size="xs" (click)="addKeywordFromInput()" [disabled]="!keywordInput.value">
                    {{ t("common.add") + " ↵" }}
                  </button>
                  <button iButton variant="secondary" size="xs" (click)="isAddKeywordVisible.set(false)">
                    {{ t("common.close") }}
                  </button>
                </div>
              </div>
              @if (targetingMode()) {
                <ISwitchButton
                  [options]="[MatchType.phrase, MatchType.exact]"
                  [buttonTexts]="['common.phrase', 'common.exact']"
                  [buttonTooltips]="['', '']"
                  [selected]="matchType()"
                  (buttonClicked)="setMatchType($event)"
                />
              }
              <div class="pr-3">
                <ICheckbox
                  [value]="isAllSelected()"
                  (valueChange)="selectAllKeywords()"
                  [disabled]="keywords().length === 0"
                />
              </div>
            </div>
          } @else {
            <button
              iButton
              class="w-full"
              size="lg"
              variant="secondary"
              (click)="isAddKeywordVisible.set(!isAddKeywordVisible())"
            >
              <IIcon name="add" />
              {{ t("common.add_keyword") }}
            </button>
          }
        }
        @if (filteredKeywords().length === 0) {
          <div class="mt-8 text-center text-sm text-gray-600">{{ t("keyword-manager.no_keywords") }}</div>
        }

        <ul class="divide-y divide-gray-100">
          @for (keyword of filteredKeywords(); track keyword) {
            <li
              class="group flex items-center justify-between px-4 py-3 duration-100"
              (click)="!isReadOnly() ? handleKeywordClick($event, keyword) : null"
              [ngClass]="{
                'bg-gray-50': keywordChecked().has(keyword),
                'cursor-pointer hover:bg-gray-50': !isReadOnly(),
              }"
            >
              <div class="flex items-center gap-2">
                @if (targetingMode()) {
                  <IBadge
                    size="xs"
                    variant="soft"
                    [label]="keyword.matchType === MatchType.exact ? t('common.exact') : t('common.phrase')"
                    class="select-none"
                    [color]="keyword.matchType === MatchType.exact ? 'green' : 'gray'"
                  />
                }
                <span class="text-sm font-medium tracking-tight text-gray-700 select-none">{{
                  keyword.targetingValue
                }}</span>
              </div>

              <div class="flex items-center gap-2">
                <button
                  iButton
                  variant="secondary"
                  size="icon-sm"
                  class="opacity-0 group-hover:opacity-100"
                  (click)="$event.stopPropagation(); copyKeyword(keyword)"
                >
                  <IIcon name="copyO" />
                </button>
                @if (!isReadOnly()) {
                  <div
                    class="opacity-0 group-hover:opacity-100"
                    [ngClass]="{ 'opacity-100': keywordChecked().has(keyword) }"
                  >
                    <ICheckbox [value]="keywordChecked().has(keyword)" />
                  </div>
                }
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</ng-container>
